import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ILogger, LoggerService } from '../../core/shared/logger.service';
import { UserNotification } from '../model/user-notification';
import { UserNotificationHandler } from './user-notification-handler';
import { TranslationService } from '../../core/shared/translation.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ProjectMachineDocumentHandlerService implements UserNotificationHandler {

  private logger: ILogger;

  constructor(
    private router: Router,
    private translateService: TranslateService,
    logger: LoggerService
  ) {
    this.logger = logger.getLogger('ProjectMachineDocumentHandlerService');
  }

  public getNotificationTypes(): Array<{ id: string, label: string }> {
    const result = [
      { id: 'projectMachineDocument_initial', label: '' },
      { id: 'projectMachineDocument_in_review', label: '' },
      { id: 'projectMachineDocument_rejected', label: '' },
      { id: 'projectMachineDocument_reviewed', label: '' },
      { id: 'projectMachineDocument_published', label: '' }
    ];

    result.forEach(item => {
      const state = item.id
        .split('_')
        .slice(1)
        .join('_');

      item.label = 
        `${this.translateService.instant('user-notifications.handler.project-machine-document.title')} ${this.translateService.instant('user-notifications.handler.project-machine-document.' + state)}`;
    });

    return result;
  }

  formatTitle(notification: UserNotification): string {
    this.logger.debug('Formating notification title with id', notification.id);

    if (!notification || !notification.type) {
      this.logger.debug('Notification is null, skipping');
      return null;
    }

    const state = notification.type
      .split('_')
      .slice(1)
      .join('_');

    return `${this.translateService.instant('user-notifications.handler.project-machine-document.title')} ${this.translateService.instant('user-notifications.handler.project-machine-document.' + state)}`;
  }

  formatDescription(notification: UserNotification): string {
    this.logger.debug('Formating notification with id', notification.id);

    if (!notification || !notification.type || !notification.additionalInfo) {
      this.logger.debug('Notification is null, skipping');
      return null;
    }

    const project = notification.additionalInfo['project'] && notification.additionalInfo['project'].name || 'Unknown';
    const documentName = notification.additionalInfo['machineDocument'] && notification.additionalInfo['machineDocument'].name || 'Unknown';
    const machineSerialNr = notification.additionalInfo['projectMachine'] && notification.additionalInfo['projectMachine'].name || 'Unknown';
    const machineType = notification.additionalInfo['projectMachineType'] && notification.additionalInfo['projectMachineType'].name || 'Unknown';

    return `Project: ${project} | Document: ${documentName} | Machine: ${machineSerialNr} (${machineType})`;
  }

  navigate(notification: UserNotification): Observable<void> {
    this.logger.debug('Navigating to user notification with id', notification.id);

    if (!notification || !notification.type || !notification.additionalInfo) {
      this.logger.debug('Notification is null, skipping');
      return null;
    }

    const projectId = notification.additionalInfo['project'] && notification.additionalInfo['project'].id || null;
    const projectMachineId = notification.additionalInfo['projectMachine'] && notification.additionalInfo['projectMachine'].id || null;
    const documentId = notification.additionalInfo['machineDocument'] && notification.additionalInfo['machineDocument'].id || null;

    const route = ['assessments', projectId, 'machines', projectMachineId, 'documents', documentId, 'review'];

    return from(this.router.navigate(route))
      .pipe(
        map(_ => null)
      );
  }

}
